import { useEffect, useRef, useState } from "react"

export const useTooltipOnOverflow = <T extends HTMLElement>() => {
    const ref = useRef<T>(null)
    const [shouldShowTooltip, setShouldShowTooltip] = useState(false)

    useEffect(() => {
        const checkOverflow = () => {
            if (ref.current) {
                const element = ref.current
                const hasOverflow = element.scrollWidth > element.clientWidth
                setShouldShowTooltip(hasOverflow)
            }
        }

        checkOverflow()

        const resizeObserver = new ResizeObserver(checkOverflow)
        if (ref.current) {
            resizeObserver.observe(ref.current)
        }

        return () => {
            resizeObserver.disconnect()
        }
    }, [])

    return { ref, shouldShowTooltip }
}
